// Carry Roll TopControlBar — basic/advanced toggle + carry/total mode toggle.

import type { CSSProperties } from 'react';
import { useStore } from '../../store';
import { InputMode, DistanceMode } from '@carry-roll/shared-types';

function activeToggleStyle(active: boolean, color: string): CSSProperties | undefined {
  return active
    ? {
        borderColor: color,
        color,
        backgroundColor: 'color-mix(in srgb, ' + color + ' 14%, transparent)',
        fontWeight: 'var(--fw-medium)',
      }
    : undefined;
}

export function TopControlBar() {
  const inputMode = useStore((s) => s.inputMode);
  const distanceMode = useStore((s) => s.distanceMode);
  const setInputMode = useStore((s) => s.setInputMode);
  const setDistanceMode = useStore((s) => s.setDistanceMode);
  const resetInputs = useStore((s) => s.resetInputs);

  return (
    <div
      className="flex flex-wrap items-center gap-3 p-3"
      style={{ backgroundColor: 'var(--color-surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--color-border)' }}
      data-testid="top-control-bar"
    >
      <div role="group" aria-label="Input mode" className="flex items-center gap-1">
        <button
          className="btn"
          aria-pressed={inputMode === InputMode.Basic}
          onClick={() => setInputMode(InputMode.Basic)}
          style={activeToggleStyle(inputMode === InputMode.Basic, 'var(--color-accent)')}
        >
          Basic
        </button>
        <button
          className="btn"
          aria-pressed={inputMode === InputMode.Advanced}
          onClick={() => setInputMode(InputMode.Advanced)}
          style={activeToggleStyle(inputMode === InputMode.Advanced, 'var(--color-accent)')}
        >
          Advanced
        </button>
      </div>
      <div role="group" aria-label="Distance mode" className="flex items-center gap-1">
        <button
          className="btn"
          aria-pressed={distanceMode === DistanceMode.Carry}
          onClick={() => setDistanceMode(DistanceMode.Carry)}
          style={activeToggleStyle(distanceMode === DistanceMode.Carry, 'var(--color-carry)')}
        >
          Carry
        </button>
        <button
          className="btn"
          aria-pressed={distanceMode === DistanceMode.Total}
          onClick={() => setDistanceMode(DistanceMode.Total)}
          style={activeToggleStyle(distanceMode === DistanceMode.Total, 'var(--color-total)')}
        >
          Total
        </button>
      </div>
      <button className="btn ml-auto" onClick={resetInputs} aria-label="Load a sample driver shot">
        Sample shot
      </button>
    </div>
  );
}
